"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var PlayerStatisticsDetailsCtl = /** @class */ (function (_super) {
    __extends(PlayerStatisticsDetailsCtl, _super);
    function PlayerStatisticsDetailsCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this._errDialog = errDialog;
        return _this;
    }
    PlayerStatisticsDetailsCtl.prototype.ResetData = function () {
        this.DATA = {
            total_deposits_count: 0,
            custom_zone_title: "",
            is_custom_zone: false,
            range_bet_bonus_amount: 0,
            range_bet_money_amount: 0,
            range_bonus_completed_amount: 0,
            range_bonus_completed_count: 0,
            range_brand_profit_amount: 0,
            range_comission_deposit_amount: 0,
            range_comission_withdraw_amount: 0,
            range_deposit_amount: 0,
            range_deposits_count: 0,
            range_partner_profit_amount: 0,
            range_win_bonus_amount: 0,
            range_win_money_amount: 0,
            range_withdraw_amount: 0,
            range_withdraws_count: 0,
            total_bet_bonus_amount: 0,
            total_bet_money_amount: 0,
            total_bonus_completed_amount: 0,
            total_bonus_completed_count: 0,
            total_brand_profit_amount: 0,
            total_comission_deposit_amount: 0,
            total_comission_withdraw_amount: 0,
            total_deposit_amount: 0,
            total_partner_profit_amount: 0,
            total_win_bonus_amount: 0,
            total_win_money_amount: 0,
            total_withdraw_amount: 0,
            total_withdraws_count: 0,
            multiaccounts_count_by_withdraws: 0,
            multiaccounts_count_by_ip: 0,
            multiaccounts_count_by_password: 0
        };
    };
    PlayerStatisticsDetailsCtl.prototype.LoadData = function (data, onDone) {
        var _this = this;
        webAApi_1.DetailsPlayerStatisticsGet.exec({
            usr_player_id: data.usr_player_id,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day
        }, function (resp) {
            _this.DATA.custom_zone_title = resp.custom_zone_title;
            _this.DATA.is_custom_zone = resp.is_custom_zone;
            _this.DATA.total_deposits_count = resp.total_deposits_count;
            _this.DATA.total_withdraws_count = resp.total_withdraws_count;
            _this.DATA.total_deposit_amount = resp.total_deposit_amount;
            _this.DATA.total_withdraw_amount = resp.total_withdraw_amount;
            _this.DATA.total_bet_money_amount = resp.total_bet_money_amount;
            _this.DATA.total_win_money_amount = resp.total_win_money_amount;
            _this.DATA.total_bet_bonus_amount = resp.total_bet_bonus_amount;
            _this.DATA.total_win_bonus_amount = resp.total_win_bonus_amount;
            _this.DATA.total_brand_profit_amount = resp.total_brand_profit_amount;
            _this.DATA.total_partner_profit_amount = resp.total_partner_profit_amount;
            _this.DATA.total_bonus_completed_count = resp.total_bonus_completed_count;
            _this.DATA.total_bonus_completed_amount = resp.total_bonus_completed_amount;
            _this.DATA.total_comission_deposit_amount = resp.total_comission_deposit_amount;
            _this.DATA.total_comission_withdraw_amount = resp.total_comission_withdraw_amount;
            _this.DATA.range_deposits_count = resp.range_deposits_count;
            _this.DATA.range_withdraws_count = resp.range_withdraws_count;
            _this.DATA.range_deposit_amount = resp.range_deposit_amount;
            _this.DATA.range_withdraw_amount = resp.range_withdraw_amount;
            _this.DATA.range_bet_money_amount = resp.range_bet_money_amount;
            _this.DATA.range_win_money_amount = resp.range_win_money_amount;
            _this.DATA.range_bet_bonus_amount = resp.range_bet_bonus_amount;
            _this.DATA.range_bet_money_amount = resp.range_bet_money_amount;
            _this.DATA.range_brand_profit_amount = resp.range_brand_profit_amount;
            _this.DATA.range_partner_profit_amount = resp.range_partner_profit_amount;
            _this.DATA.range_bonus_completed_count = resp.range_bonus_completed_count;
            _this.DATA.range_bonus_completed_amount = resp.range_bonus_completed_amount;
            _this.DATA.range_comission_deposit_amount = resp.range_comission_deposit_amount;
            _this.DATA.range_comission_withdraw_amount = resp.range_comission_withdraw_amount;
            _this.DATA.multiaccounts_count_by_withdraws = 0;
            _this.DATA.multiaccounts_count_by_ip = resp.multiaccounts_count_by_ip_address;
            _this.DATA.multiaccounts_count_by_password = resp.multiaccounts_count_by_password;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerStatisticsDetailsCtl.prototype.LoadDataByWithdraw = function (data, onDone) {
        var _this = this;
        webAApi_1.DetailsPlayerStatisticsByWithdrawalReqGet.exec({
            money_flow_key: data.money_flow_key,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day
        }, function (resp) {
            _this.DATA.custom_zone_title = resp.custom_zone_title;
            _this.DATA.is_custom_zone = resp.is_custom_zone;
            _this.DATA.total_deposits_count = resp.total_deposits_count;
            _this.DATA.total_withdraws_count = resp.total_withdraws_count;
            _this.DATA.total_deposit_amount = resp.total_deposit_amount;
            _this.DATA.total_withdraw_amount = resp.total_withdraw_amount;
            _this.DATA.total_bet_money_amount = resp.total_bet_money_amount;
            _this.DATA.total_win_money_amount = resp.total_win_money_amount;
            _this.DATA.total_bet_bonus_amount = resp.total_bet_bonus_amount;
            _this.DATA.total_win_bonus_amount = resp.total_win_bonus_amount;
            _this.DATA.total_brand_profit_amount = resp.total_brand_profit_amount;
            _this.DATA.total_partner_profit_amount = resp.total_partner_profit_amount;
            _this.DATA.total_bonus_completed_count = resp.total_bonus_completed_count;
            _this.DATA.total_bonus_completed_amount = resp.total_bonus_completed_amount;
            _this.DATA.total_comission_deposit_amount = resp.total_comission_deposit_amount;
            _this.DATA.total_comission_withdraw_amount = resp.total_comission_withdraw_amount;
            _this.DATA.range_deposits_count = resp.range_deposits_count;
            _this.DATA.range_withdraws_count = resp.range_withdraws_count;
            _this.DATA.range_deposit_amount = resp.range_deposit_amount;
            _this.DATA.range_withdraw_amount = resp.range_withdraw_amount;
            _this.DATA.range_bet_money_amount = resp.range_bet_money_amount;
            _this.DATA.range_win_money_amount = resp.range_win_money_amount;
            _this.DATA.range_bet_bonus_amount = resp.range_bet_bonus_amount;
            _this.DATA.range_bet_money_amount = resp.range_bet_money_amount;
            _this.DATA.range_brand_profit_amount = resp.range_brand_profit_amount;
            _this.DATA.range_partner_profit_amount = resp.range_partner_profit_amount;
            _this.DATA.range_bonus_completed_count = resp.range_bonus_completed_count;
            _this.DATA.range_bonus_completed_amount = resp.range_bonus_completed_amount;
            _this.DATA.range_comission_deposit_amount = resp.range_comission_deposit_amount;
            _this.DATA.range_comission_withdraw_amount = resp.range_comission_withdraw_amount;
            _this.DATA.multiaccounts_count_by_withdraws = resp.multiaccounts_count_by_withdraws;
            _this.DATA.multiaccounts_count_by_ip = resp.multiaccounts_count_by_ip_address;
            _this.DATA.multiaccounts_count_by_password = resp.multiaccounts_count_by_password;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerStatisticsDetailsCtl.prototype.LoadDataByDeposit = function (data, onDone) {
        var _this = this;
        webAApi_1.DetailsPlayerStatisticsByDepositReqGet.exec({
            money_flow_key: data.money_flow_key,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day
        }, function (resp) {
            _this.DATA.custom_zone_title = resp.custom_zone_title;
            _this.DATA.is_custom_zone = resp.is_custom_zone;
            _this.DATA.total_deposits_count = resp.total_deposits_count;
            _this.DATA.total_withdraws_count = resp.total_withdraws_count;
            _this.DATA.total_deposit_amount = resp.total_deposit_amount;
            _this.DATA.total_withdraw_amount = resp.total_withdraw_amount;
            _this.DATA.total_bet_money_amount = resp.total_bet_money_amount;
            _this.DATA.total_win_money_amount = resp.total_win_money_amount;
            _this.DATA.total_bet_bonus_amount = resp.total_bet_bonus_amount;
            _this.DATA.total_win_bonus_amount = resp.total_win_bonus_amount;
            _this.DATA.total_brand_profit_amount = resp.total_brand_profit_amount;
            _this.DATA.total_partner_profit_amount = resp.total_partner_profit_amount;
            _this.DATA.total_bonus_completed_count = resp.total_bonus_completed_count;
            _this.DATA.total_bonus_completed_amount = resp.total_bonus_completed_amount;
            _this.DATA.total_comission_deposit_amount = resp.total_comission_deposit_amount;
            _this.DATA.total_comission_withdraw_amount = resp.total_comission_withdraw_amount;
            _this.DATA.range_deposits_count = resp.range_deposits_count;
            _this.DATA.range_withdraws_count = resp.range_withdraws_count;
            _this.DATA.range_deposit_amount = resp.range_deposit_amount;
            _this.DATA.range_withdraw_amount = resp.range_withdraw_amount;
            _this.DATA.range_bet_money_amount = resp.range_bet_money_amount;
            _this.DATA.range_win_money_amount = resp.range_win_money_amount;
            _this.DATA.range_bet_bonus_amount = resp.range_bet_bonus_amount;
            _this.DATA.range_bet_money_amount = resp.range_bet_money_amount;
            _this.DATA.range_brand_profit_amount = resp.range_brand_profit_amount;
            _this.DATA.range_partner_profit_amount = resp.range_partner_profit_amount;
            _this.DATA.range_bonus_completed_count = resp.range_bonus_completed_count;
            _this.DATA.range_bonus_completed_amount = resp.range_bonus_completed_amount;
            _this.DATA.range_comission_deposit_amount = resp.range_comission_deposit_amount;
            _this.DATA.range_comission_withdraw_amount = resp.range_comission_withdraw_amount;
            _this.DATA.multiaccounts_count_by_withdraws = 0;
            _this.DATA.multiaccounts_count_by_ip = resp.multiaccounts_count_by_ip_address;
            _this.DATA.multiaccounts_count_by_password = resp.multiaccounts_count_by_password;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return PlayerStatisticsDetailsCtl;
}(BaseController_1.BaseController));
exports.PlayerStatisticsDetailsCtl = PlayerStatisticsDetailsCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ctl/PlayerStatisticsDetailsCtl.ts
// module id = 166
// module chunks = 0